export function stripPhone(value) {
  if (typeof value !== 'string') return ''
  let phone = value.replace(/\D/g, '')
  if (phone.indexOf('90') === 0 && phone.length === 12) phone = phone.slice(2)
  if (phone.indexOf('0') === 0 && phone.length === 11) phone = phone.slice(1)
  // A Turkish mobile number is exactly 10 digits (server: /^5\d{9}$/); clamp
  // rather than leave a pasted/overlong value permanently invalid.
  return phone.slice(0, 10)
}

export function formatPhone(value) {
  const phone = stripPhone(value)
  return phone.replace(/^(\d{3})(\d{3})(\d{2})(\d{2})$/, '($1) $2 $3 $4')
}

export function isValidPhone(value) {
  return /^5\d{9}$/.test(stripPhone(value))
}
